import { Component, OnInit } from '@angular/core';
import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { UserService } from './services/user.service';
import {TeacherService} from "./services/teacher.service";
import {Teacher} from "./interfaces/teacher";
import {getDownloadURL, getStorage, ref} from "firebase/storage";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Green & Healthy Schools';
  isAdmin = false;
  username = '';
  userId: string | null = null;
  userImg: string = '';
  isLoggedIn: boolean = false;
  teacher: Teacher | null = null;
  role: string | null = null;

  constructor(private userService: UserService, private teacherService: TeacherService) {}

  ngOnInit() {
    this.userService.isAdmin$.subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
    });

    const auth = getAuth();
    onAuthStateChanged(auth, async (user) => {
      if (user?.uid) {
        this.userId = user.uid;

        // Update LOGIN/LOGOUT link
        const loginNav = document.querySelector("#loginNav") as HTMLLinkElement;
        if (loginNav) loginNav.innerHTML = "LOGOUT";
        this.isLoggedIn = true;

        // Fetch teacher's first name for navbar
        await this.getTeacherInfo();
      } else {
        this.username = 'LOGIN';
        this.isLoggedIn = false;
      }
    });
  }

  // Sign out function
  async userSignOut() {
      await signOut(getAuth());
      this.username = 'MY PROFILE';
      this.userId = null;
      this.teacher = null;
  }

  // get teacher info
  async getTeacherInfo() {
    try {
      this.teacher = await this.teacherService.getTeacher();
      if (this.teacher) {
        // username
        this.username = this.teacher.fName || 'MY PROFILE';

        //user role
        this.role = this.teacher.role;

        // user image
        if (this.teacher.img) {
          const storage = getStorage();
          const storageRef = ref(storage, this.teacher.img);
          getDownloadURL(storageRef)
            .then(url => this.userImg = url)
            .catch(err => {
              console.error('Error fetching image URL:', err);
              this.userImg = '';
            });
        }
      } else {
        this.username = 'MY PROFILE';
      }
    } catch (error) {
      console.error('Error fetching teacher document:', error);
      this.username = 'MY PROFILE';
    }
  }
}
